import React from 'react';
import { FileText } from 'lucide-react';
import MobileSidebarAccordion from '@/components/ui/MobileSidebarAccordion';
import SidebarHeader from '@/components/ui/SidebarHeader';
import PageCreationForm from './PageCreationForm';
import ProjectSelectionDropdown from '@/components/image-generator/ImageGeneration/ProjectSelectionDropdown';

interface PrivateTextSidebarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSimpleCreate: (title: string, pageType?: string) => void;
  onAdvancedCreate: (formData: PageCreationFormData) => void;
  isCreatingSimple?: boolean;
  isGeneratingAdvanced?: boolean;
  generationProgress?: number;
  generationStatus?: 'idle' | 'processing' | 'success' | 'error';
  selectedProjectId?: string | null;
  onProjectChange?: (projectId: string | null) => void;
  selectedDocumentType?: string | null;
  onDocumentTypeChange?: (documentType: string | null) => void;
}

export interface PageCreationFormData {
  title: string;
  pageType?: string;
  purpose?: string;
  writingStyle?: string;
}

const PrivateTextSidebar: React.FC<PrivateTextSidebarProps> = ({
  searchQuery,
  onSearchChange,
  onSimpleCreate,
  onAdvancedCreate,
  isCreatingSimple = false,
  isGeneratingAdvanced = false,
  selectedProjectId,
  onProjectChange,
  selectedDocumentType,
  onDocumentTypeChange,
}) => {
  return (
    <MobileSidebarAccordion
      variant="purple"
      persistKey="private-text-sidebar"
      defaultExpanded={false}
      className="h-full"
    >
      <SidebarHeader 
        title="Create Document" 
        icon={FileText} 
        variant="purple"
      />
      
      {/* Project Selection Dropdown */}
      {onProjectChange && (
        <div className="w-full">
          <ProjectSelectionDropdown
            selectedProjectId={selectedProjectId}
            onProjectChange={onProjectChange}
          />
        </div>
      )}
      
      <PageCreationForm
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        onSimpleCreate={onSimpleCreate}
        onAdvancedCreate={onAdvancedCreate}
        isCreatingSimple={isCreatingSimple}
        isGeneratingAdvanced={isGeneratingAdvanced}
        selectedDocumentType={selectedDocumentType}
        onDocumentTypeChange={onDocumentTypeChange}
      />
    </MobileSidebarAccordion>
  );
};

export default PrivateTextSidebar; 